"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlTabLayoutPill", function ($mdButtonInkRipple, directiveUtils, $animate) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: "^tlTabLayout",
    template: '<div class="ts-tab-pill tl-panel-menu" ng-click="onPillClick()" ng-class="{selected : isSelectedTab(), \'panel-opened\' : tab.panelOpened}"></div>',
    link: function link($scope, $el, $attrs, tabsetCtrl) {
      $mdButtonInkRipple.attach($scope, $el);
      var tab = $scope.$eval("tab");
      $el.attr("tabset-fragment", tab.fragment);

      // PGA : bug entre ng-repeat et l'ajout de classe selected qui pose soucis lors du déplacement dans la section reporting.
      //       a priori on a pas besoin des animations angular ici, donc je désactive.
      $animate.enabled($el, false);
      $scope.onPillClick = function () {
        tabsetCtrl.changeUrl(tab);
      };
      $scope.isSelectedTab = function () {
        return tabsetCtrl.isSelectedTab(tab);
      };
      var directiveName = tab.pillDirective || tabsetCtrl.getConfig().pillDirective;
      directiveUtils.compileDirective(directiveName)($scope, function (clone) {
        clone.appendTo($el);
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tabset/tlTabLayoutPill.js
// module id = 3010
// module chunks = 13